namespace Portico.Services {

    import IServiceUrl = Portico.Models.Interfaces.IServiceUrl;

    export abstract class ServiceBase<TSettings extends IServiceUrl> {
        private className = 'Portico.Services.ServiceBase';

        constructor(
            protected $http: ng.IHttpService,
            protected $q: ng.IQService,
            protected dataService: Portico.Services.DataService,
            private modalService: Portico.Services.IModalService,
            private errorService: Portico.Services.IErrorService,
            private $rootScope: ng.IRootScopeService
        ) {
            this.$http.defaults.headers.common['accept'] = 'application/json';
            this.$http.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';
        }

        public createInstance(serviceUrl: TSettings): IServiceInstance {
            return new ServiceInstance<TSettings>(
                serviceUrl,
                this.$http,
                this.$q,
                this.dataService,
                this.modalService,
                this.errorService,
                this.$rootScope,
                this.requestToken.bind(this),
                this.getHttpConfig.bind(this)
            );
        }

        protected abstract requestToken(serviceUrl: TSettings): ng.IPromise<string>;
        protected getHttpConfig(serviceUrl: TSettings, token: string): ng.IRequestConfig {
            const config = {} as ng.IRequestConfig;

			if (!_.startsWith(token, 'Bearer')) {
				token = 'Bearer ' + token;
			}

            config.headers = {
                'Authorization': token
            };

            return config;
        }
    }
}